import { ls } from "@/shared/utils/localStorage";
import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from "@reduxjs/toolkit";
import { alertsSuppressionService } from "../services/alertsSuppressionService";
import type { RootState } from "@/store/store";
import type { AlertsSuppressionState } from "../types/alertsSuppression.types";

const initialState: AlertsSuppressionState = {
  SuppressedAlertsDst: [],
  _lastRefreshedTimeDst: null,
  status: {
    SuppressedAlertsDst: "idle",
  },
  filters: {},
  filtersInitialised: true,
};

export const fetchSuppressedAlerts = createAsyncThunk(
  "alertsSuppressionStore/fetchSuppressedAlerts",
  async (timeZone: string) => {
    return await alertsSuppressionService.GetSuppressedAlerts(timeZone);
  },
);

const alertsSuppressionSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters(state) {
      state.filters = {
        // Add filters if needed
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppressedAlerts.fulfilled, (state, action) => {
        state.SuppressedAlertsDst = action.payload;
        state.status.SuppressedAlertsDst = "succeeded";
      })
      .addCase(fetchSuppressedAlerts.rejected, (state) => {
        state.status.SuppressedAlertsDst = "failed";
      });
  },
});

export const selectSuppressAlertsStatus = (state: RootState) =>
  state.alertsSuppression.SuppressedAlertsDst;

export const suppressAlertsData = (state: RootState) =>
  state.alertsSuppression.SuppressedAlertsDst;

export const { setFilters, clearFilters } = alertsSuppressionSlice.actions;
export default alertsSuppressionSlice.reducer;
